import React, {useEffect, useContext} from 'react';
import {Form, Input, InputNumber, Button, Checkbox} from 'antd';
import {UserContext} from '../../../context/UserContext';

const EditModalContent = ({data, setOpen, updateCallback}) => {

	useEffect(() => {
		console.log({data})
	},[])

	const onFinish = (values) => {
		let meta;
		try{
			meta = JSON.parse(values.metadata)
		}
		catch {
			meta = {}
		}
		values.metadata = meta;

	  console.log('Success:', values);
	  updateCallback(data.id, values)
	  setOpen(false)
	};
	const onFinishFailed = (errorInfo) => {
	  console.log('Failed:', errorInfo);
	};

	return (
		<div className='flex justify-center '>
			<Form id='editCropForm' className='max-w-[80%]' onFinish={onFinish}
				    onFinishFailed={onFinishFailed}>
				<Form.Item className='mr-2' name='name' label="Name" initialValue={`${data?.name}`}
					rules={[
	                {
	                  	required: true,
	                  	message: 'name required',
	                },
              	]}
              	>
		        	<Input placeholder="Name" />
		      	</Form.Item>
		      	<Form.Item className='mr-2' name='display_name' label="Display Name" initialValue={`${data?.display_name}`}
					rules={[
	                {
	                  	required: true,
	                  	message: 'name required',
	                },
              	]}
              	>
		        	<Input placeholder="Display Name" />
		      	</Form.Item>
		      	<Form.Item className='mr-2' name='icon' label="Icon" initialValue={`${data?.icon}`}
					rules={[
	                {
	                  	required: true,
	                  	message: 'icon required',
	                },
              	]}
              	>
		        	<Input placeholder="Icon" />
		      	</Form.Item>
		      	<Form.Item className='mr-2' name='metadata' label="Metadata" initialValue={JSON.stringify(data?.metadata)}
					rules={[
		                {
		                  	required: true,
		                  	message: 'metadata required',
		                },
	              	]}
	              	>
		        		<Input.TextArea/>
		      	</Form.Item>
		      	<Form.Item className='mr-2' name='is_active' valuePropName="checked" initialValue={data?.is_active} label="Active"
	              	>
		        	<Checkbox />
		      	</Form.Item>
		      	<Form.Item>
			        <Button type="primary" htmlType="submit">Submit</Button>
		      	</Form.Item>
			</Form>
		</div>
	)
}

export default EditModalContent;